/* global addToCart  */
document.addEventListener('DOMContentLoaded', () => {
	const bundleForm = document.getElementById('bundle-form');
	bundleForm.addEventListener('submit', handleSubmitEvent);
});

function handleSubmitEvent(event) {
	event.preventDefault();
	const bundleForm = event.target;
	const { bundleColletionTitle, id } = bundleForm.dataset;
    const bundleItems = [];

	bundleForm.querySelectorAll('.product-bundle').forEach((product, i) => {
		const { value: quantity } = product.querySelector('.quantity-selector__input');
		// eslint-disable-next-line no-magic-numbers
		if (Number(quantity) < 1) {
			return;
		}
		const { variantId } = product.dataset;

        // Create a bundle item object
        const bundleItem = {
            variantId: variantId,
            quantity: Number(quantity), // Convert quantity to a number
        };

        bundleItems.push(bundleItem);
	});
	if (!bundleItems.length) {
		// eslint-disable-next-line quotes
		return alert("Translation missing: he.bundles.error_message");
	}
	const formData = {
		items: [
			{
				id: id,
				quantity: 1,
				title: bundleColletionTitle,
				properties: {
					_bundle: bundleItems,
				},
			},
		],
	};
	addToCartAndRedirect(formData);
}

async function addToCartAndRedirect(formData) {
	const response = await addToCart(formData);
	const data = await response.json();
	if (!response.ok) {
		alert(data.description);
	}
	window.location.href = '/cart';
}
